import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=962bcc96&scoped=true&"
import script from "./SessionList.vue?vue&type=script&lang=js&"
export * from "./SessionList.vue?vue&type=script&lang=js&"
import style0 from "./SessionList.vue?vue&type=style&index=0&id=962bcc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962bcc96",
  null
  
)

export default component.exports